module.exports = __webpack_public_path__ + "static/landing-3c16029ca559f423573d7dc2224abeae.jpeg";